import { useState, useEffect } from "react";
import AutoComplete from "../../material/autoComplete/AutoComplete";
import * as publicApi from "../../../service/publicApi";

const HospitalRegistration = ({ hospitalId, setHospitalId }) => {
  const [hospitalList, setHospitalList] = useState("");

  const getHospitalList = async () => {
    try {
      let res = await publicApi.getHospitalList();

      if (res["data"]["code"] === 200) {
        setHospitalList(
          res["data"]["hospital_list"].map((item) => {
            return {
              id: item["hospital_id"],
              name: item["hospital_name"],
            };
          }),
        );
      }
    } catch (error) {
      console.error("Error hospital catch");
    }
  };

  useEffect(() => {
    const fetchAPI = async () => {
      await getHospitalList();
    };

    fetchAPI();
  }, []);

  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <AutoComplete
      
        id={hospitalId}
        label="โรงพยาบาลต้นสังกัด"
        placeholder="โรงพยาบาลต้นสังกัด"
        list={hospitalList}
        callBack={(res) => {
          setHospitalId(res["id"]);
        }}
      ></AutoComplete>
    </div>
  );
};

export default HospitalRegistration;
